// extracted by mini-css-extract-plugin
export default {"wrap":"consultationsUser_wrap__AQNtS"};